<app-modal-shell [config]="modalConfig">
  <div modal-content>
    <ng-container *ngIf="data.template">
      <ng-container *ngTemplateOutlet="data.template; context: data.templateContext"></ng-container>
    </ng-container>

    <div *ngIf="!data.template" [innerHTML]="getFormattedMessage()"></div>

    <div *ngIf="!data.template && !data.content && !data.message" class="default-content">
      <p>¿Está seguro de que desea continuar con esta acción?</p>
      <p><strong>Esta acción no se puede deshacer.</strong></p>
    </div>

    <form [formGroup]="form" *ngIf="data.requiresReason" class="form-container">
      <mat-form-field class="full-width">
        <mat-label>Razón de eliminación</mat-label>
        <input matInput formControlName="deletionReason" placeholder="Indique brevemente la razón" maxlength="100">
        <mat-hint>{{ (form.get('deletionReason')?.value || '').length }}/100</mat-hint>
        <mat-error *ngIf="form.get('deletionReason')?.hasError('required')">
          La razón de eliminación es requerida
        </mat-error>
        <mat-error *ngIf="form.get('deletionReason')?.hasError('minlength')">
          La razón debe tener al menos 5 caracteres
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="onCancel()">{{ data.cancelButtonText || 'Cancelar' }}</button>
    <button mat-flat-button color="warn" type="button" (click)="onConfirm()">
      {{ data.confirmButtonText || 'Eliminar' }}
    </button>
  </ng-container>
</app-modal-shell>
